import React, { useEffect } from "react";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Tooltip } from "@mui/material";
import { generateInspectionReportPrint } from "./inspectionReportPrint";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL, reportLetter } from "../../../global";
import { toast } from "react-toastify";
import { useParams, useLocation } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import CommonTableIR from "./commonTableIR";
import { CheckboxField, DateInput, TextFields } from "../../../utils/Custom/custominput";
import IRImageUpload from "./IRImageUpload";
import { handleApproval, RejectionModal } from "../inspection/inspectionUtils";
import AddTable from "../../dynamicTables/dynamicTable";
import { extractBodyRows, extractHeaders, groupTableData } from "../../../utils/commonComponent/tableUtils";
import moment from "moment";
import DownloadPdfLoaderModal from "../../../utils/commonComponent/downloadPdfLoader";
import { FileUploadComponent } from "./IRMultipleFileUpload";
import TimeSheetModal from "../inspectionTaskList/timesheetmodal";
import { getPermissions } from "../rbac/hasAccess";
import {applicableDocumentsHeaders, areaofConcernHeaders, detailsItemHeaders, detailsWitnessHeaders, detailsReviewedHeaders, detailsEquipmentInspectionHeaders, INS_ACT_Checkbox_Types, GEN_TextField_Types, defaultApplicableDocuments } from "../GeneralIR/generalIRConst";
import { handleTableSubmit, makeHandlers } from "../GeneralIR/editGeneralIR";
import HseCheckPoints from "../GeneralIR/hseCheckPoints";
import ImageUploadCommonButton from "../../../utils/commonComponent/ImageUploadCommonButton";
import { validateRequiredFields } from "../../../utils/commonComponent/errorAlert";

const InspectionReport = (props) => {
  const params = useParams();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const isQRRoute = location.pathname.includes("/inspectionReport/print/qr/");
  const PrintView = props?.print == true;
  const [inputStates, setInputStates] = React.useState({
    reportNo: "",
    controlId: "",
    rfiDetails: "",
    inspectionDates: "",
    locationOfInspection: "",
    clientName: "",
    endUser: "",
    project: "",
    contractorNameNumber: "",
    vendor: "",
    poNumberClient: "",
    subVendor: "",
    poNumberVendor: "",
    komPom: 0,
    materialInspection: 0,
    inProcessInspection: 0,
    finalInspection: 0,
    documentReview: 0,
    fatSat: 0,
    wpsPqrWpq: 0,
    preDispatchInspection: 0,
    laboratoryTesting: 0,
    coatingInspection: 0,
    calibration: 0,
    reInspection: 0,
  });

  const [itemDetails, setItemDetails] = React.useState([]);
  const [originalItemDetails, setOriginalItemDetails] = React.useState([]);
  const [deletedItemIds, setDeletedItemIds] = React.useState([]);
  const itemHandlers = makeHandlers(setItemDetails, setDeletedItemIds);

  const [applicableDocRows, setApplicableDocRows] = React.useState(params.id == 0 ? defaultApplicableDocuments : []);
  const [originalApplicableDocRows, setOriginalApplicableDocRows] = React.useState([]);
  const [deletedApplicableDocIds, setDeletedApplicableDocIds] = React.useState([]);
  const applicableDocHandlers = makeHandlers(setApplicableDocRows, setDeletedApplicableDocIds);

  const [areaOfConcernRows, setAreaOfConcernRows] = React.useState([]);
  const [originalAreaOfConcernRows, setOriginalAreaOfConcernRows] = React.useState([]);
  const [deletedAreaOfConcernIds, setDeletedAreaOfConcernIds] = React.useState([]);
  const areaOfConcernHandlers = makeHandlers(setAreaOfConcernRows, setDeletedAreaOfConcernIds);

  const [detailsWitnessRows, setDetailsWitnessRows] = React.useState([]);
  const [originalDetailsWitnessRows, setOriginalDetailsWitnessRows] = React.useState([]);
  const [deletedDetailsWitnessIds, setDeletedDetailsWitnessIds] = React.useState([]);
  const detailsWitnessHandlers = makeHandlers(setDetailsWitnessRows, setDeletedDetailsWitnessIds);

  const [detailsReviewedRows, setDetailsReviewedRows] = React.useState([]);
  const [originalDetailsReviewedRows, setOriginalDetailsReviewedRows] = React.useState([]);
  const [deletedDetailsReviewedIds, setDeletedDetailsReviewedIds] = React.useState([]);
  const detailsReviewedHandlers = makeHandlers(setDetailsReviewedRows, setDeletedDetailsReviewedIds);

  const [detailsEquipmentRows, setDetailsEquipmentRows] = React.useState([]);
  const [originalDetailsEquipmentRows, setOriginalDetailsEquipmentRows] = React.useState([]);
  const [deletedDetailsEquipmentIds, setDeletedDetailsEquipmentIds] = React.useState([]);
  const detailsEquipmentHandlers = makeHandlers(setDetailsEquipmentRows, setDeletedDetailsEquipmentIds);

  const [uploadedImages, setUploadedImages] = React.useState([]);
  const [photoRowId, setPhotoRowId] = React.useState(null);

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const [hseData, setHseData] = React.useState({
    c1: 0,
    c2: 0,
    c3: 0,
    c4: 0,
    c5: 0,
    c6: 0,
    c7: 0,
    c8: 0,
    c9: 0,
    c10: 0,
    c11: 0,
    c12: 0,
  });
  const [originalHseData, setOriginalHseData] = React.useState({});
  const [hseId, setHseId] = React.useState(null);
  const updateHse = (key, value) => {
    setHseData((prev) => ({ ...prev, [key]: value }));
  };
  const userId = localStorage.getItem("id");

  const [isDataLoaded, setIsDataLoaded] = React.useState(false);
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);

  const [tableData, setTableData] = React.useState([]);
  const [rejectionModalOpen, setRejectionModalOpen] = React.useState(false);

  const [timeSheetModalOpen, setTimeSheetModalOpen] = React.useState(false);
  const [timeSheetRow, setTimeSheetRow] = React.useState(null);

  const userType = localStorage.getItem("type") || "";
  const hasRole = ["2"].some((role) =>(localStorage.getItem("roles") || "").split(",").includes(role)) || userType == 1;
  // Functions

  // const fieldCharLimits = {
  //   projectName: 230, // 255
  //   clientId: 100, // 100
  //   supplierName: 230, // 255
  //   inspectionAddress: 230, // 255
  //   supplierContactName: 100, // 100
  //   supplierContactEmail: 100, // 100
  //   scopeVisit: 230, // 255
  //   comp_Enviroment_HealthSafety: 450, // 500
  //   punchList: 1400, // 1500
  //   // documents: 230,                   // 255
  // };

  // const updateInputObject = (key, value) => {
  //   const limit = fieldCharLimits[key];
  //   if (limit && typeof value === "string" && value.length > limit) {
  //     toast.warning(
  //       `You have reached the maximum ${limit} allowed text Limit `
  //     );
  //     return;
  //   }
  //   setInputStates((prevInputStates) => ({
  //     ...prevInputStates,
  //     [key]: value,
  //   }));
  // };

  useEffect(() => {
    // if (!inputStates.reportNo) {
    //   updateInputObject(
    //     "reportNo",
    //     `${reportLetter}/IR/Enter_Client/Enter_location-manufacturer_name/inspectorName/${inputStates.inspectionNumber}`
    //   );
    // }
    if(!inputStates.clientName && inputStates.companyName){
      updateInputObject("clientName",inputStates.companyName);
    }
  }, [inputStates.companyName]);

  useEffect(() => {
    if (!inputStates.locationOfInspection && inputStates.inspectionLocation) {
      updateInputObject("locationOfInspection", inputStates.inspectionLocation);
    }
  }, [inputStates.inspectionLocation]);

  const fetchInspectionReport = async () => {
    try {
      const query = `SELECT ir.*, c.companyName, u.userName AS inspectedByName, u.userSign AS inspectedBySign, a.userName AS approvedByName, a.userSign AS approvedBySign, jr.inspectionLocation, jri.inspectionNumber, jr.jobNumber FROM IR ir LEFT JOIN jobRegisterInspection jri ON ir.jobRegisterInspectionId = jri.id LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients c ON jr.clientId = c.id  LEFT JOIN users u ON ir.inspectorId = u.id LEFT JOIN users a ON ir.approvedBy = a.id WHERE ir.jobRegisterInspectionId = ${params.id}`;
      const [inspectionData] = await fetchQuery(query);
      setInputStates(inspectionData);

      const itemResponse = await fetchQuery(`select * from IR_InspectedItems where generalIRId = ${params.id}`);
      setItemDetails(itemResponse || []);
      setOriginalItemDetails(itemResponse || []);

      const applicableDocResponse = await fetchQuery(`select * from IR_ReferenceDocuments where generalIRId = ${params.id}`);
      // setApplicableDocRows(applicableDocResponse || []);
      setApplicableDocRows(applicableDocResponse?.length > 0 ? applicableDocResponse : defaultApplicableDocuments);
      setOriginalApplicableDocRows(applicableDocResponse || []);

      const areaOfConcernResponse = await fetchQuery(`select * from IR_AreaConcern where generalIRId = ${params.id}`);
      setAreaOfConcernRows(areaOfConcernResponse || []);
      setOriginalAreaOfConcernRows(areaOfConcernResponse || []);

      const witnessResponse = await fetchQuery(`select * from IR_InspectionWitnessed where generalIRId = ${params.id}`);
      setDetailsWitnessRows(witnessResponse || []);
      setOriginalDetailsWitnessRows(witnessResponse || []);

      const reviewedResponse = await fetchQuery(`select * from IR_ReviewedDoc where generalIRId = ${params.id}`);
      setDetailsReviewedRows(reviewedResponse || []);
      setOriginalDetailsReviewedRows(reviewedResponse || []);

      const equipmentResponse = await fetchQuery(`select * from IR_EquipmentUsed where generalIRId = ${params.id}`);
      setDetailsEquipmentRows(equipmentResponse || []);
      setOriginalDetailsEquipmentRows(equipmentResponse || []);

      const hseResponse = await fetchQuery(`select * from IR_HseCheckPoints where generalIRId = ${params.id}`);
      if (hseResponse?.[0]) {
        const { id, generalIRId, ...rest } = hseResponse[0];
        setHseId(id);
        setHseData(rest);
        setOriginalHseData(rest);
      }

      const photoResponse = await fetchQuery(`select * from generalEvaluationPhotos where generalIRId = ${params.id}`);
      if (photoResponse?.[0]) {
        const { id, generalIRId, imagename, imageFilePath } = photoResponse[0];
        setPhotoRowId(id);
        const names = imagename ? imagename.split("||") : [];
        const paths = imageFilePath ? imageFilePath.split(",") : [];
        const parsed = paths.map((path, i) => ({
          imagePath: path,
          imagesName: names[i] || "",
        }));
        setUploadedImages(parsed);
      }

      setIsDataLoaded(true);
    } catch (error) {
      console.error("Error fetchInspectionReport:", error);
      setIsDataLoaded(true);
    }
  };

  const onSubmit = async () => {
    // console.log("Payload:", {
    //   ...inputStates,
    //   itemDetails,
    // });

    const required = [
      { value: inputStates.reportNo, label: "Report No is required" },
    ];
    if (!validateRequiredFields(required)) return;
        const { companyName, inspectionLocation, approvedByName, approvedBySign, inspectionNumber, inspectedBySign, inspectedByName, jobNumber, ...restInputStates } = inputStates;

    const payload = {
      ...restInputStates,
      createBy: localStorage.getItem("id"),
      approvedBy: null,
      rejectedBy: null,
    };
    // Add inspectorId only if userType is "2"
    if (userType == 2) {
      payload.inspectorId = userId;
      payload.requestApproval = 1;
    }

    try {
      const Url = BASE_URL + "IR";
      let IR_Id = params.id;
      
      //  Inspection Report
      await axiosWithToken.patch(Url + `/${inputStates.id}`, payload);
      toast.success("Inspection Report Updated Successfully!");

      // Details of Inspected Items (Fill the data as per PO/Offer list)
      await handleTableSubmit( itemDetails, originalItemDetails, deletedItemIds, "IR_InspectedItems", IR_Id);
      // Details of Applicable Documents
      await handleTableSubmit( applicableDocRows, originalApplicableDocRows, deletedApplicableDocIds, "IR_ReferenceDocuments", IR_Id);
      // Details of Area of Concern
      await handleTableSubmit( areaOfConcernRows, originalAreaOfConcernRows, deletedAreaOfConcernIds, "IR_AreaConcern", IR_Id);

      // Details of Witness
      await handleTableSubmit( detailsWitnessRows, originalDetailsWitnessRows, deletedDetailsWitnessIds, "IR_InspectionWitnessed", IR_Id);

      // Details of Reviewed
      await handleTableSubmit( detailsReviewedRows, originalDetailsReviewedRows, deletedDetailsReviewedIds, "IR_ReviewedDoc", IR_Id);

      // Details of Equipment
      await handleTableSubmit( detailsEquipmentRows, originalDetailsEquipmentRows, deletedDetailsEquipmentIds, "IR_EquipmentUsed", IR_Id);

      const HseUrl = BASE_URL + "IR_HseCheckPoints";
      if (hseId) {
        // only patch if something changed vs fetched data
        const originalHse = originalHseData;
        const changedHse = Object.fromEntries(Object.entries(hseData).filter(([k, v]) => originalHse[k] !== v));
        if (Object.keys(changedHse).length > 0) {
          await axiosWithToken.patch(HseUrl + `/${hseId}`, changedHse);
        }
      } else {
        const hseRes = await axiosWithToken.post(HseUrl, {
          ...hseData,
          generalIRId: IR_Id,
        });
        setHseId(hseRes.data.insertId);
      }

      const PhotoUrl = BASE_URL + "generalEvaluationPhotos";
      if (uploadedImages.length > 0) {
        const imagename = uploadedImages.map((img) => img.imagesName || "").join("||");
        const imageFilePath = uploadedImages.map((img) => img.imagePath || "").join(",");
        if (photoRowId) {
          await axiosWithToken.patch(PhotoUrl + `/${photoRowId}`, {
            imagename,
            imageFilePath,
          });
        } else {
          const photoRes = await axiosWithToken.post(PhotoUrl, {
            imagename,
            imageFilePath,
            generalIRId: IR_Id,
          });
          setPhotoRowId(photoRes.data.insertId);
        }
      }

      setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const loadAllData = async () => {
      await fetchInspectionReport();
    };
    loadAllData();
  }, []);

  // Auto-download PDF for QR route
  useEffect(() => {
    if (isQRRoute && isDataLoaded && inputStates.id) {
      console.log("All data loaded, generating PDF...");
      const timer = setTimeout(() => {
        generateInspectionReportPrint(
          inputStates,
          itemDetails,
          uploadedImages,
          tableData,
          setDownloadPdfloading
        );
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [isQRRoute, isDataLoaded, inputStates.id]);

  return (
    <div className={isQRRoute ? "p-8" : ""}>
      <div className="flex justify-between mb-7">
        <Text variant="h3" bold className="text-blue-600">
          Inspection Report
        </Text>
        <br />
        <div className="flex gap-5">
          {(permissions.pdfDownload || permissions.allAccess) &&
            PrintView &&
            !isQRRoute && (
              <AddButton
                id="btn-add-outline"
                label="Download Report"
                onClick={() =>
                  generateInspectionReportPrint(
                    inputStates,
                    itemDetails,
                    uploadedImages,
                    tableData,
                    setDownloadPdfloading
                  )
                }
              />
            )}
          {/* Help icon for non-PrintView */}
          {/* {!PrintView && (
            <a
              href="https://DYC Global.bfiinfotech.co.in/api/fileUpload/uploads/1774253224__Sample.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                color: "#1976d2", // MUI primary blue
                fontWeight: 500,
                textDecoration: "none",
                padding: "4px 8px",
                borderRadius: "4px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#e3f2fd")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <Tooltip title="Sample PDF">
                <PictureAsPdfIcon fontSize="small" />
                PDF
              </Tooltip>
            </a>
          )} */}
        </div>
      </div>

      <div>
        <TextFields
          label={"Report No"}
          value={inputStates?.reportNo || ""}
          onChange={(e) => updateInputObject("reportNo", e.target.value)}
          multiline
          minRows={1}
          maxRows={10}
        />
        <br />
        <br />

        {/* Section 1 & 2 */}
        <div className="border border-gray-400">
          <div className="grid grid-cols-1 md:grid-cols-[65%_35%]">
            <div className="bg-gray-100 font-semibold px-3 py-2 border-b border-gray-400 md:border-r">
              1. General Information
            </div>
            <div className="hidden md:block bg-gray-100 font-semibold px-3 py-2 border-b border-gray-400">
              2. Type of Inspection Activity:
              <span className="font-normal text-xs block">
                (Select the Applicable Stage)
              </span>
            </div>
          </div>

          <div className="hidden md:block">
            {GEN_TextField_Types.map((field, i) => (
              <div
                key={field.key}
                className="grid grid-cols-[65%_35%] border-t border-gray-400"
              >
                <div className="flex gap-2 px-3 py-2 border-r border-gray-400">
                  <div className="min-w-[200px]">
                    <span className="font-semibold text-sm">{field.label}</span>
                    {field.subLabel && (
                      <span className="text-xs text-gray-500 block">
                        {field.subLabel}
                      </span>
                    )}
                  </div>
                  <div className="flex-1">
                    {field.isDate ? (
                      <DateInput
                        id={field.key}
                        label={field.label}
                        value={inputStates?.[field.key] || ""}
                        onChange={(value) =>
                          updateInputObject(field.key, value)
                        }
                      />
                    ) : (
                      <TextFields
                        value={inputStates?.[field?.key] || ""}
                        onChange={(e) =>
                          updateInputObject(field.key, e.target.value)
                        }
                        multiline={!!field.multiline}
                        minRows={1}
                        maxRows={4}
                      />
                    )}
                  </div>
                </div>
                <div className="px-3 py-2 flex items-center">
                  {INS_ACT_Checkbox_Types[i] && (
                    <CheckboxField
                      label={INS_ACT_Checkbox_Types[i].label}
                      value={inputStates?.[INS_ACT_Checkbox_Types[i].key]}
                      onChange={(val) =>
                        updateInputObject(INS_ACT_Checkbox_Types[i].key, val)
                      }
                    />
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="md:hidden">
            <div className="border-t border-gray-400">
              {GEN_TextField_Types.map((field) => (
                <div
                  key={field.key}
                  className="flex flex-col gap-1 px-3 py-2 border-b border-gray-400"
                >
                  <div>
                    <span className="font-semibold text-sm">{field.label}</span>
                    {field.subLabel && (
                      <span className="text-xs text-gray-500 block">
                        {field.subLabel}
                      </span>
                    )}
                  </div>
                  <TextFields
                    value={inputStates?.[field.key] || ""}
                    onChange={(e) =>
                      updateInputObject(field.key, e.target.value)
                    }
                    multiline={!!field.multiline}
                    minRows={1}
                    maxRows={4}
                  />
                </div>
              ))}
            </div>
            <div className="border-t-2 border-gray-500">
              <div className="bg-gray-100 font-semibold px-3 py-2 border-b border-gray-400 text-sm">
                2. Type of Inspection Activity:
                <span className="font-normal text-xs block">
                  (Select the Applicable Stage)
                </span>
              </div>
              <div className="grid grid-cols-2 gap-0">
                {INS_ACT_Checkbox_Types.map((act) => (
                  <div
                    key={act.key}
                    className="px-3 py-2 border-b border-r border-gray-400"
                  >
                    <CheckboxField
                      label={act.label}
                      value={inputStates?.[act.key]}
                      onChange={(val) => updateInputObject(act.key, val)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <br />

        {/* Section 3 */}
        <CommonTableIR
          headers={detailsItemHeaders}
          rows={itemDetails}
          onChange={itemHandlers.update}
          onDeleteRow={itemHandlers.remove}
          onAddRow={itemHandlers.add}
          label={"Add Item Row"}
          headingLabel={
            "3. Details of Inspected Items (Fill the data as per PO/Offer list)"
          }
        />

        <br />

        {/* Section 4 */}
        <CommonTableIR
          headers={applicableDocumentsHeaders}
          rows={applicableDocRows}
          onChange={applicableDocHandlers.update}
          onDeleteRow={applicableDocHandlers.remove}
          onAddRow={applicableDocHandlers.add}
          label={"Add Row"}
          headingLabel={
            "4. Applicable Reference Documents: (Fill the applicable section and if not mention not applicable):"
          }
        />

        <br />

        {/* Section 5 */}
        <CommonTableIR
          headers={areaofConcernHeaders}
          rows={areaOfConcernRows}
          onChange={areaOfConcernHandlers.update}
          onDeleteRow={areaOfConcernHandlers.remove}
          onAddRow={areaOfConcernHandlers.add}
          label={"Add Row"}
          headingLabel={
            "5. Area of Concern (From This Visit & Previous visit, do not delete the concerns after closing):"
          }
        />

        <br />

        {/* Section 6 */}
        <CommonTableIR
          headers={detailsWitnessHeaders}
          rows={detailsWitnessRows}
          onChange={detailsWitnessHandlers.update}
          onDeleteRow={detailsWitnessHandlers.remove}
          onAddRow={detailsWitnessHandlers.add}
          label={"Add Row"}
          headingLabel={
            "6. Details of Inspection stages witnessed: (Mention Witnessed activities as per scope – Findings of Inspection)"
          }
        />

        <br />

        {/* Section 7 */}
        <CommonTableIR
          headers={detailsReviewedHeaders}
          rows={detailsReviewedRows}
          onChange={detailsReviewedHandlers.update}
          onDeleteRow={detailsReviewedHandlers.remove}
          onAddRow={detailsReviewedHandlers.add}
          label={"Add Row"}
          headingLabel={
            "7. Details of Reviewed Documents: (Mention reviewed documents as per scope with findings)"
          }
        />

        <br />
        <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          8. Result Summary: (Mention Conclusive Result of Inspection here)
        </Text>

        <TextFields
          label={
            "8. Result Summary: (Mention Conclusive Result of Inspection here)"
          }
          value={inputStates?.resultSummary || ""}
          onChange={(e) => updateInputObject("resultSummary", e.target.value)}
          multiline
          minRows={1}
          maxRows={10}
        />
        <br />
        <br />

        {/* Section 9 */}
        <CommonTableIR
          headers={detailsEquipmentInspectionHeaders}
          rows={detailsEquipmentRows}
          onChange={detailsEquipmentHandlers.update}
          onDeleteRow={detailsEquipmentHandlers.remove}
          onAddRow={detailsEquipmentHandlers.add}
          label={"Add Row"}
          headingLabel={
            "9. Details of Equipment(s) / Instrument(s) used for Measuring / Testing during Inspection:"
          }
        />

        <br />
        <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          10. Pending Activities:(Write pending activities from this visit
          against offered scope / RFI)
        </Text>

        <TextFields
          label={
            "10. Pending Activities:(Write pending activities from this visit against offered scope / RFI)"
          }
          value={inputStates?.pendingActivities || ""}
          onChange={(e) =>
            updateInputObject("pendingActivities", e.target.value)
          }
          multiline
          minRows={1}
          maxRows={10}
        />

        <br />
        <br />

        <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          11. Identification of the Inspected Items: (Mention identification
          details where stamping has been done)
        </Text>

        <TextFields
          label={
            "11. Identification of the Inspected Items: (Mention identification details where stamping has been done)"
          }
          value={inputStates?.identificationOfItems || ""}
          onChange={(e) =>
            updateInputObject("identificationOfItems", e.target.value)
          }
          multiline
          minRows={1}
          maxRows={10}
        />

        <br />
        <br />

        <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          12. Non-Conformity Report:(Strike through options that are not
          applicable)
        </Text>

        <TextFields
          label={
            "12. Non-Conformity Report:(Strike through options that are not applicable)"
          }
          value={inputStates?.nonConformity || ""}
          onChange={(e) => updateInputObject("nonConformity", e.target.value)}
          multiline
          minRows={1}
          maxRows={10}
        />

        <br />
        <br />

        <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          13. List of Attachments: (Write short description of supporting
          documents to inspection)
        </Text>

        <TextFields
          label={
            "13. List of Attachments: (Write short description of supporting documents to inspection)"
          }
          value={inputStates?.listOfAttachments || ""}
          onChange={(e) =>
            updateInputObject("listOfAttachments", e.target.value)
          }
          multiline
          minRows={1}
          maxRows={10}
        />

        <br />
        <br />

        <HseCheckPoints
          data={hseData}
          onChange={updateHse}
          // PrintView={PrintView}
        />

        <br />

        <>
          <Text
            variant="h6"
            bold
            className="text-blue-700 bg-blue-50 px-3 mb-5"
          >
            15. Authorized Signatures:
          </Text>

          <div className="border border-gray-400 text-sm">
            {/* Headers */}
            <div className="grid grid-cols-2">
              <div className="font-semibold text-center px-3 py-2 border-b border-r border-gray-400">
                DYC Global Pvt. Ltd. Surveyor:
              </div>
              <div className="font-semibold text-center px-3 py-2 border-b border-gray-400">
                DYC Global Pvt. Ltd. Reviewer:
              </div>
            </div>

            {/* Signature canvas */}
            <div className="grid grid-cols-2">
              <div className="flex flex-col items-center justify-center px-3 py-4 border-b border-r border-gray-400 min-h-[100px]">
                <ImageUploadCommonButton
                  url={inputStates?.Surveyorsign || ""}
                  updateUrl={(url) => updateInputObject("Surveyorsign", url)}
                  imgShow={true}
                />
              </div>
              <div className="flex flex-col items-center justify-center px-3 py-4 border-b border-gray-400 min-h-[100px]">
                <ImageUploadCommonButton
                  url={inputStates?.ReviewerSign || ""}
                  updateUrl={(url) => updateInputObject("ReviewerSign", url)}
                  imgShow={true}
                />
              </div>
            </div>

            {/* Name and Date */}
            <div className="grid grid-cols-2">
              <div className="grid grid-cols-2 gap-3 px-3 py-2 border-r border-gray-400">
                <TextFields
                  label="Name"
                  value={inputStates?.SurveyorName || ""}
                  onChange={(e) =>
                    updateInputObject("SurveyorName", e.target.value)
                  }
                />
                <DateInput
                  label="Date"
                  value={inputStates?.SurveyorDate || null}
                  onChange={(value) => updateInputObject("SurveyorDate", value)}
                />
              </div>
              <div className="grid grid-cols-2 gap-3 px-3 py-2">
                <TextFields
                  label="Name"
                  value={inputStates?.ReviewerName || ""}
                  onChange={(e) =>
                    updateInputObject("ReviewerName", e.target.value)
                  }
                />
                <DateInput
                  label="Date"
                  value={inputStates?.ReviewerDate || null}
                  onChange={(value) => updateInputObject("ReviewerDate", value)}
                />
              </div>
            </div>
          </div>
        </>

        {/* Section 8 */}
        <IRImageUpload
          label="16. Evaluation Photographs:"
          images={uploadedImages}
          setImages={setUploadedImages}
        />

        <br />
        {/* <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 my-5">
          17. TimeSheet
        </Text>
        <AddButton
          id="btn-TimeSheet-outline"
          label="TimeSheet"
          onClick={() => {
            setTimeSheetRow(inputStates);
            setTimeSheetModalOpen(true);
          }}
          className="text-green-600"
        />
        <br /> */}

        <br />
      </div>
      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          {(!(userType == 2 && inputStates?.requestApproval == 2) ||
            permissions.save ||
            permissions.create ||
            permissions.allAccess) && (
            <SaveAndUpdate
              id="btn-add-outline"
              label={"Save"}
              onClick={onSubmit}
            />
          )}
        </div>
      )}
      <div className="flex gap-3 mt-10">
        {!PrintView &&
          hasRole &&
          !inputStates?.approvedBy &&
          !inputStates?.rejectedBy &&
          inputStates?.requestApproval == 2 && (
            <>
              <AddButton
                id="btn-add-outline"
                label="Approve"
                variant="approve"
                onClick={() => handleApproval([params.id])}
              />
              <AddButton
                id="btn-reject"
                label="Reject"
                variant="delete"
                onClick={() => setRejectionModalOpen(true)}
                style={{ backgroundColor: "#ef4444" }}
              />
            </>
          )}
      </div>
      <br />
      <br />
      {/* Add the modal component before the closing div */}
      <RejectionModal
        open={rejectionModalOpen}
        onClose={() => setRejectionModalOpen(false)}
        selectedIds={[params.id]}
        onSuccess={() => window.location.reload()}
      />
      {downloadPdfloading && (
        <DownloadPdfLoaderModal loading={downloadPdfloading} name={"Report"} />
      )}

      <TimeSheetModal
        open={timeSheetModalOpen}
        onClose={() => {
          setTimeSheetModalOpen(false);
          setTimeSheetRow(null);
        }}
        rowData={timeSheetRow}
      />
    </div>
  );
};

export default InspectionReport;
